import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const volumes = [{
  title: 'FOUNDATION PHASE',
  description: 'Build strong football fundamentals from day one.'
}, {
  title: 'SKILL DEVELOPMENT',
  description: 'Passing. Receiving. Dribbling. Finishing. Technical progression.'
}, {
  title: 'GAME INTELLIGENCE',
  description: 'Decision making. Awareness. Scanning. Football understanding.'
}, {
  title: 'TEAM DEVELOPMENT',
  description: 'Attacking principles. Defensive principles. Transitions. Collective play.'
}, {
  title: 'THE 365 SESSION VAULT',
  description: 'A complete library of ready-to-use training sessions for every situation.'
}, {
  title: 'COACH MANAGEMENT SYSTEM',
  description: 'Planning. Organization. Evaluation. Communication. Season management.'
}];
export function Volumes() {
  return <section className="py-20 bg-navy-950 relative" data-id="element-242">
      <div className="container mx-auto px-4" data-id="element-243">
        <div className="text-center mb-16" data-id="element-244">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide" data-id="element-245">
            THE COMPLETE 6-VOLUME SYSTEM
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-246">
          {volumes.map((vol, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gradient-to-b from-navy-800 to-navy-900 border border-navy-700 rounded-xl p-8 relative overflow-hidden group hover:border-gold-500/50 transition-colors" data-id="element-247">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-248">
                <BookOpen className="w-24 h-24 text-white" data-id="element-249" />
              </div>
              <div className="relative z-10" data-id="element-250">
                <div className="text-gold-500 font-oswald text-sm tracking-widest mb-2" data-id="element-251">
                  VOLUME {index + 1}
                </div>
                <h3 className="font-anton text-2xl text-white uppercase tracking-wide mb-4" data-id="element-252">
                  {vol.title}
                </h3>
                <p className="text-gray-400 font-medium leading-relaxed" data-id="element-253">
                  {vol.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}